document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  var navLinks = Array.prototype.slice.call(document.querySelectorAll('[data-nav-link]'));
  var demoCards = Array.prototype.slice.call(document.querySelectorAll('[data-demo-card]'));
  var cartForm = document.querySelector('.cart-form');
  var cartCheckoutForm = document.querySelector('[data-cart-checkout-form]');
  var cartQuantityInputs = Array.prototype.slice.call(document.querySelectorAll('[data-cart-quantity]'));
  var cartMessage = document.querySelector('[data-cart-message]');

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open');
    });
  }

  if (navLinks.length) {
    var getLinkSectionIds = function (link) {
      var sections = link.getAttribute('data-sections');
      if (sections) {
        return sections.split(',').map(function (value) {
          return value.trim();
        }).filter(Boolean);
      }

      var section = link.getAttribute('data-section');
      return section ? [section] : [];
    };

    var setActiveLink = function (sectionId) {
      navLinks.forEach(function (link) {
        var isActive = getLinkSectionIds(link).indexOf(sectionId) !== -1;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    navLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        var sectionId = getLinkSectionIds(link)[0];
        if (sectionId) {
          setActiveLink(sectionId);
        }

        if (nav && nav.classList.contains('is-open') && toggle) {
          nav.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });

    var sections = navLinks
      .reduce(function (allSections, link) {
        getLinkSectionIds(link).forEach(function (sectionId) {
          var section = document.getElementById(sectionId);
          if (section && allSections.indexOf(section) === -1) {
            allSections.push(section);
          }
        });
        return allSections;
      }, [])
      .filter(Boolean);

    if (sections.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var visibleEntries = entries.filter(function (entry) {
            return entry.isIntersecting;
          });

          visibleEntries.sort(function (left, right) {
            return right.intersectionRatio - left.intersectionRatio;
          });

          if (visibleEntries[0]) {
            setActiveLink(visibleEntries[0].target.id);
          }
        },
        {
          rootMargin: '-35% 0px -45% 0px',
          threshold: [0.2, 0.35, 0.6]
        }
      );

      sections.forEach(function (section) {
        observer.observe(section);
      });
    }
  }

  if (demoCards.length) {
    demoCards.forEach(function (card) {
      var button = card.querySelector('[data-demo-submit]');
      var feedback = card.querySelector('[data-demo-feedback]');

      if (!button || !feedback) {
        return;
      }

      button.addEventListener('click', function () {
        var movie = card.querySelector('[data-demo-field="movie"]');
        var actor = card.querySelector('[data-demo-field="actor"]');
        var character = card.querySelector('[data-demo-field="character"]');

        var correctCount = 0;
        var total = 3;

        if (movie && movie.value === card.getAttribute('data-answer-movie')) {
          correctCount += 1;
        }

        if (actor && actor.value === card.getAttribute('data-answer-actor')) {
          correctCount += 1;
        }

        if (character && character.value === card.getAttribute('data-answer-character')) {
          correctCount += 1;
        }

        if (correctCount === total) {
          feedback.textContent = 'Nice. You got all three parts of this example card.';
          feedback.className = 'demo-card__feedback is-success';
        } else {
          feedback.textContent = 'You got ' + correctCount + ' of 3. Correct answers: ' + card.getAttribute('data-answer-movie') + ', ' + card.getAttribute('data-answer-actor') + ', ' + card.getAttribute('data-answer-character') + '.';
          feedback.className = 'demo-card__feedback is-info';
        }
      });
    });
  }

  if (cartQuantityInputs.length) {
    var MIN_CART_QUANTITY = 1;
    var MAX_CART_QUANTITY = 100;
    var BULK_ORDER_MESSAGE = 'For bulk orders over 100 games, please contact us through the contact form.';

    var setCartMessage = function (message) {
      if (!cartMessage) {
        return;
      }

      if (message) {
        cartMessage.textContent = message;
        cartMessage.hidden = false;
      } else {
        cartMessage.textContent = '';
        cartMessage.hidden = true;
      }
    };

    var normalizeQuantityValue = function (input) {
      if (!input) {
        return MIN_CART_QUANTITY;
      }

      var parsed = parseInt(input.value, 10);

      if (isNaN(parsed) || parsed < MIN_CART_QUANTITY) {
        input.value = String(MIN_CART_QUANTITY);
        return MIN_CART_QUANTITY;
      }

      if (parsed > MAX_CART_QUANTITY) {
        input.value = String(MAX_CART_QUANTITY);
        return MAX_CART_QUANTITY;
      }

      input.value = String(parsed);
      return parsed;
    };

    var hasBulkOrderRequest = function () {
      return cartQuantityInputs.some(function (input) {
        var parsed = parseInt(input.value, 10);
        return !isNaN(parsed) && parsed > MAX_CART_QUANTITY;
      });
    };

    var validateCartQuantities = function (event) {
      if (hasBulkOrderRequest()) {
        event.preventDefault();
        setCartMessage(BULK_ORDER_MESSAGE);
        cartQuantityInputs.forEach(function (input) {
          normalizeQuantityValue(input);
        });
        return false;
      }

      cartQuantityInputs.forEach(function (input) {
        normalizeQuantityValue(input);
      });
      setCartMessage('');
      return true;
    };

    cartQuantityInputs.forEach(function (input) {
      normalizeQuantityValue(input);

      input.addEventListener('input', function () {
        if (hasBulkOrderRequest()) {
          setCartMessage(BULK_ORDER_MESSAGE);
        } else {
          setCartMessage('');
        }
      });

      input.addEventListener('blur', function () {
        normalizeQuantityValue(input);
        setCartMessage('');
      });
    });

    if (cartForm) {
      cartForm.addEventListener('submit', validateCartQuantities);
    }

    if (cartCheckoutForm) {
      cartCheckoutForm.addEventListener('submit', validateCartQuantities);
    }
  }
});